import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=6b909b4a&scoped=true&"
import script from "./UiCheckbox.vue?vue&type=script&lang=js&"
export * from "./UiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=6b909b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b909b4a",
  null
  
)

export default component.exports